// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"c41753f8","136":"c1c34a6f","142":"67552254","153":"24db1343","181":"aa7589b6","272":"8e2a14c5","459":"79e94f69","559":"258d852c","787":"c48ac27f","893":"32bd391a"}[chunkId] + ".chunk.js";
};